<template>
  <div class="d-flex ga-4">
    <img
      :src="imgSrc"
      alt="/"
      width="56px"
      height="56px"
      class="doctor-img rounded-circle"
    >
    <div>
      <div class="text--text text-subtitle-1">
        {{ fio }}
      </div>
      <div class="text--text text-body-2">
        {{ workplace }}
      </div>
      <AdminButton
        text="править"
        :link="reverseFull({ name: 'admin:info_review_change', args: [lpuReviewId] })"
        class="mt-2"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import AdminButton from 'src/components/common/AdminButton/AdminButton.vue'
import { useContextStore, useURLStore } from 'src/store'

const { context } = useContextStore()
const { reverseFull, urls, patch } = useURLStore()

if (process.env.IS_SERVER && context.request.user.is_staff && context.flavour === 'full') {
  patch({ 'admin:info_review_change': urls['admin:info_review_change'] })
}

defineProps<{
  fio: string
  workplace: string
  imgSrc: string
  lpuReviewId: number
}>()
</script>
